/* eslint-disable */
import React, { useEffect } from "react";
import { getNeighborsNotices } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const Notices = ({ getNeighborsNotices, notices, period }) => {
  useEffect(() => {
    getNeighborsNotices({
      page: 1,
      limit: 20,
    });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighborsNotices(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighborsNotices(payload);
  };

  return (
    <DataTable
      preset="notices"
      data={{
        docs: notices?.docs || [],
        totalPages: notices?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  notices: state.appCommunities.notices,
});

const mapDispatchToProps = (dispatch) => ({
  getNeighborsNotices: (payload) => dispatch(getNeighborsNotices(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notices);